import React from 'react';
import { actionIcon } from '../utils/actionIcons';

/** A spell on offer, shown as the tile it will be on the action panel. Selected tiles glow. */
export default function SpellChoiceTile({ spell, selected, onClick }) {
  const icon = actionIcon({ ...spell, kind: Number(spell.level) ? 'spell' : 'cantrip', damageText: spell.damage || '' });
  return <button type="button" aria-pressed={selected} title={spell.name} onClick={onClick}
    className={`combat-hud-resource-tile combat-hud-feature-action-tile${selected ? ' combat-hud-resource-tile--glowing' : ''}`}>
    <span className="combat-hud-resource-tile__icon" aria-hidden="true">{icon}</span>
    <span className="combat-hud-resource-tile__name">{spell.name}</span>
    {spell.listLabel && <span className="combat-hud-resource-tile__value">{spell.listLabel}</span>}
  </button>;
}
